export default __webpack_public_path__ + "static/Metropolis-SemiBold-6668c61c00739652719377939ccc3967.woff2";